import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import { Message } from 'semantic-ui-react';

import { TitledCard } from 'Components/';
import { Main } from 'Containers/';
import { FileExtensions } from 'Common/Constants/Enumeration/FileExtensions';
import { setYesNoDialogProps } from 'Components/dialogs/state/actions';
import DownloadRosterForm from './DownloadRosterForm';
import { ExportFormatType } from 'Common/Constants/Enumeration/ExportFormatType';
import { RosterCurrentBalanceFieldEnum as Fields } from 'Common/FieldEnum';
import { rosterReportConfiguration } from '../helpers/constants';
import { toastInfo, toastError } from 'Common/ToastHelper';
import MPWWebApi from 'API/MPWApi';

class DownloadRoster extends Component {
  static propTypes = {
    nextStep: PropTypes.func.isRequired,
    prevStep: PropTypes.func.isRequired,
    stepComplete: PropTypes.func.isRequired,
    isComplete: PropTypes.bool.isRequired,
    fiscalYear: PropTypes.number.isRequired,
  };

  state = { loading: false };

  getMainProps = () => {
    const { isComplete, nextStep, prevStep, setYesNoDialogProps } = this.props;

    return {
      toolbox: {
        rightButtons: [
          {
            content: 'Next',
            onClick: () => {
              // If this step has already been completed or there aren't any unclosded dates go to the next step.
              if (isComplete) {
                nextStep();
              } else {
                setYesNoDialogProps({
                  showDialog: true,
                  title: 'Continue?',
                  question: `Would you like to continue without downloading your Roster/Current Balance report?`,
                  yesCallback: nextStep,
                  noCallback: () => {},
                  cancelCallback: () => {},
                });
              }
            },
            disabled: this.props.loading,
          },
        ],
        backButtonProps: { shown: true, callback: prevStep },
        shown: true,
      },
    };
  };

  downloadRosterReport = async values => {
    const exportType = values[Fields.ExportType];
    const { stepComplete } = this.props;

    try {
      this.setState({ loading: true });

      const dataFound = await MPWWebApi.postDownloadFile(
        'Reports/RosterBalanceReport',
        `RosterBalanceReport.${FileExtensions[exportType]}`,
        { ...rosterReportConfiguration, [Fields.ExportType]: exportType },
        exportType
      );

      if (!dataFound) {
        toastInfo('No Data Found');
      }

      stepComplete();
    } catch (error) {
      toastError('There was a problem generating the report.');
    }

    this.setState({ loading: false });
  };

  render() {
    return (
      <Main {...this.getMainProps()}>
        <TitledCard title={'Download Roster/Current Balance'}>
          <Message>
            <Message.Content>
              <Message.Header>
                We recommend you download your roster report before closing the
                school year.
              </Message.Header>
              To customize this report go to the{' '}
              <Link to="/rostercurrentbalance">Roster/Current Balance</Link>{' '}
              report page.
            </Message.Content>
          </Message>

          <DownloadRosterForm
            onSubmit={this.downloadRosterReport}
            loading={this.state.loading}
            initialValues={{ ExportType: ExportFormatType.PortableDocFormat }}
          />
        </TitledCard>
      </Main>
    );
  }
}

const mapDispatchToProps = {
  setYesNoDialogProps,
};

const mapStateToProps = state => ({});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(DownloadRoster)
);



// WEBPACK FOOTER //
// ./src/pages/CloseSchoolYear/components/DownloadRoster.js